// 将图片压缩成固定的宽高
export const compressImage = function (base64ImageStr, maxWidth, maxHeight) {
  const imgElement = document.createElement('img')
  imgElement.src = base64ImageStr
  return new Promise((resolve, reject) => {
    // Wait for the image to load before continuing.
    imgElement.onload = function () {
      const canvas = document.createElement('canvas')
      let width = imgElement.width
      let height = imgElement.height
      // Check if the image needs to be resized.
      if (maxWidth && maxHeight) {
        width = maxWidth
        height = maxHeight
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(imgElement, 0, 0, width, height)
        // Get the compressed data URL.
        const base64ImageDataUri = canvas.toDataURL()
        resolve(base64ImageDataUri)
      } else {
        reject()
      }
    }
  })
}
